import React, { useState } from 'react';

import {
  GroupSubscriptionRecipient,
  GroupSubscriptionType,
} from '@utils/backend-api/groupSubscriptions';

import EditRecipientCard from './EditRecipientCard';
import ShowRecipientCard from './ShowRecipientCard';
import styles from './styles.module.scss';

const SubscriptionOverview = ({
  recipients,
  groupSubscriptionType,
}: {
  recipients: GroupSubscriptionRecipient[];
  groupSubscriptionType: GroupSubscriptionType;
}) => {
  const [editRecipientId, setEditRecipientId] = useState<number | null>();
  return (
    <div className={styles.overViewContainer} data-test="recipient-overview-container">
      {recipients.map((recipient) =>
        recipient.recipientId !== editRecipientId ? (
          <ShowRecipientCard
            recipient={recipient}
            setEditRecipientId={setEditRecipientId}
            key={recipient.recipientId}
          />
        ) : (
          <EditRecipientCard
            recipient={recipient}
            setEditRecipientId={setEditRecipientId}
            groupSubscriptionType={groupSubscriptionType}
            key={recipient.recipientId}
          />
        )
      )}
    </div>
  );
};

export default SubscriptionOverview;
